import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { VirtualTradingButtonContainer } from './styled';
import { AuthModalType, VirtualTradingButtonProps } from '../../types';
import useVirtualLogin from '../../hooks/useVirtualLogin';

export default function VirtualTradingButton({
  title,
  type,
  setLoading,
}: VirtualTradingButtonProps) {
  const { switchToVirtual } = useVirtualLogin(setLoading);

  const imgWidth = {
    [AuthModalType.LOGIN]: '40px',
    [AuthModalType.REGISTER]: '40px',
    [AuthModalType.PROGRESS]: '32px',
  };

  const getTitle = () => {
    if (type === AuthModalType.REGISTER) {
      return (
        // @ts-expect-error
        <Text family="bold" ml="8px">
          Virtual <br /> Trading
        </Text>
      );
    }

    return (
      // @ts-expect-error
      <Text family="bold" ml="8px">
        {title}
      </Text>
    );
  };

  return (
    <VirtualTradingButtonContainer
      data-cy="virtual-trading-button-auth"
      width={type === AuthModalType.REGISTER ? '50%' : ''}
      justify={type === AuthModalType.REGISTER ? 'left' : 'center'}
      onClick={switchToVirtual}
    >
      <Flex justify="center" align="center">
        <Image
          alt="virtual-trading"
          src="/img/virtual.svg"
          width={imgWidth[type]}
        />
        {getTitle()}
      </Flex>
    </VirtualTradingButtonContainer>
  );
}
